import styled from "styled-components";
import { mediaMaxWidth } from "../../../theme/mediaQueriesTemplates";

interface IWrapperProps {
  pdfExport?: boolean;
  totalJobsPerSectorSelected?: boolean;
}

export const Wrapper = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  background-color: #fff;
  padding: ${(props: IWrapperProps) => !props.pdfExport && "10px"};
  border-radius: 8px;
  position: relative;
  box-shadow: ${(props: IWrapperProps) =>
    !props.pdfExport && "rgb(220, 220, 220) 0px 0px 15px"};
  transform: ${(props: IWrapperProps) =>
    props.pdfExport && "scale(0.75) translateX(-9px) translateY(-9px)"};
  transform: ${(props: IWrapperProps) =>
    props.pdfExport &&
    props.totalJobsPerSectorSelected &&
    "scale(0.75) translateX(-123px) translateY(-9px)"};
  margin: ${(props: IWrapperProps) => !props.pdfExport && "0 10px"};
  overflow: hidden;
  max-width: ${(props: IWrapperProps) => props.pdfExport && "620px"};

  &.animated.delay-8 {
    animation-delay: 1.2s;
  }

  ${mediaMaxWidth.mediumDesktop} {
    margin: ${(props: IWrapperProps) => !props.pdfExport && "10px auto"};
    width: ${(props: IWrapperProps) => !props.pdfExport && "650px"};
  }

  ${mediaMaxWidth.tablet} {
    width: ${(props: IWrapperProps) =>
      !props.pdfExport && "calc(100vw - 40px)"};
  }

  ${mediaMaxWidth.phone} {
    width: ${(props: IWrapperProps) =>
      !props.pdfExport && "calc(100vw - 20px)"};
    margin: ${(props: IWrapperProps) => !props.pdfExport && "5px 10px"};
  }
`;

export const Chart = styled.div`
  display: flex;
  flex: 1;
  justify-content: center;
  align-items: center;
  flex-direction: column;

  .chart-item {
    width: 100%;
  }
`;
